import { gql } from '@apollo/client';

const checkpointNotificationFragment = gql`
  fragment CheckpointNotificationFields on CheckpointNotification {
    OrgUnitId
    AppraisalId
    CheckPoint {
      Id
      DataCollectionDate
    }
    IsEdited
  }
`;

export default checkpointNotificationFragment;
